// extracted by mini-css-extract-plugin
export var addButton = "_f6-0";
export var border = "_f6-8";
export var check = "_f6-h";
export var danger = "_f6-6";
export var dropdownContainer = "_f6-1";
export var editModalBody = "_f6-j";
export var footerContainer = "_f6-i";
export var fullWidth = "_f6-a";
export var hide = "_f6-9";
export var icon = "_f6-3";
export var input = "_f6-7";
export var inputFlex = "_f6-b";
export var inputWrapper = "_f6-c";
export var manualFocus = "_f6-5";
export var optionButton = "_f6-4";
export var pillWrapper = "_f6-e";
export var pointer = "_f6-2";
export var showOverflow = "_f6-f";
export var tagsFlex = "_f6-d";
export var xButton = "_f6-g";